export default __webpack_public_path__ + "static/media/m29.45b40ae7.png";